import { TextField } from '@mui/material';
import ReactInputMask from 'react-input-mask';
import { useEffect, useState } from 'react';

interface Props {
  label: string;
  value: string;
  name: string;
  className?: string;
  error?: any;
  hasError?: boolean;
  handleBlur?: (e: any) => void;
  handleChange?: (e: any) => void;
  disabled?: boolean;
}

export const InputCNPJCPF = ({
  label,
  value,
  name,
  className,
  error,
  hasError,
  handleBlur,
  handleChange,
  disabled,
}: Props) => {
  const [mask, setMask] = useState('99.999.999/9999-99'); // Inicializa com máscara para CPF

  const updateMask = (inputValue: string) => {
    if (inputValue.length > 11 && inputValue.length <= 14) {
      setMask('99.999.999/9999-99'); // Máscara de CNPJ
    } else if (inputValue.length <= 11) {
      setMask('999.999.999-999'); // Máscara de CPF
    } 
  };

  // Atualiza a máscara quando o valor é alterado
  useEffect(() => {
    if (value) {
      updateMask(value.toString().replace(/\D/g, ''));
    }
  }, [value]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value?.replace(/\D/g, '');

    updateMask(inputValue);

    if (handleChange) {
      // [AJUSTE 07/08/2026] entrega o valor SEM máscara.
      //
      // Antes calculava inputValue e mandava o evento original assim mesmo, então
      // o Formik gravava "12.345.678/0001-90" no banco. A tela de pesquisa, por
      // outro lado, tira a máscara antes de consultar - um LIKE de dígitos contra
      // um valor pontuado nunca casa, e o cliente "sumia" da busca.
      //
      // A máscara continua na TELA: quem a aplica é o ReactInputMask sobre o
      // value. O que muda é só o que sai daqui para o formulário.
      //
      // Mesmo padrão do InputMoney: evento sintético em vez do original, porque o
      // handleChange do Formik só olha target.name e target.value.
      handleChange({ target: { name, value: inputValue } });
    }
  };

  return (
    <ReactInputMask
      disabled={disabled}
      id={name}
      mask={mask}
      value={value}
      maskChar=' '
      onBlur={handleBlur}
      onChange={handleInputChange}
    >
      {/*// @ts-expect-error - .*/}
      {() => (
        <TextField
          size='small'
          disabled={disabled}
          name={name}
          InputLabelProps={{ shrink: true }}
          label={label}
          className={className}
          error={hasError}
          helperText={error}
        />
      )}
    </ReactInputMask>
  );
};
